module.exports = __webpack_public_path__ + "42e451452837f64783891c2792277e7e.svg";